import { Environment } from '../enums/environment';
export var defaultSentryConfig = {
    dsn: 'https://0c793eedc5844dcba60c15ee31addb6a@sentry.wixpress.com/314',
    config: {
        environment: process.env.NODE_ENV === 'production'
            ? Environment.Prod
            : Environment.Dev,
    }
};
